// Native scrolling owns touch, wheel and keyboard; controls only move one card.
document.querySelectorAll('[data-trade-rail]').forEach((rail) => {
  const controls = rail.nextElementSibling;
  if (!controls?.matches('.bbtr-rail-controls')) return;
  const buttons = controls.querySelectorAll('button');
  const update = () => {
    buttons[0].disabled = rail.scrollLeft < 2;
    buttons[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  };
  buttons.forEach((button, index) => button.addEventListener('click', () => {
    const step = rail.children[1].offsetLeft - rail.children[0].offsetLeft;
    rail.scrollBy({left: index ? step : -step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }));
  rail.addEventListener('scroll', update, {passive: true});
  new ResizeObserver(update).observe(rail);
  controls.hidden = false;
  update();
});
const cta = document.querySelector('.bbtr-mobile-cta');
const hero = document.querySelector('[data-trade-hero]');
const form = document.querySelector('.bbtr-form');
if (cta && hero && form && 'IntersectionObserver' in window) {
  let heroVisible = true;
  let formVisible = false;
  const update = () => { cta.hidden = heroVisible || formVisible; };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === hero) heroVisible = entry.intersectionRatio > 0;
      if (entry.target === form) formVisible = entry.intersectionRatio > 0;
    });
    update();
  });
  observer.observe(hero);
  observer.observe(form);
}
